/**
 * Created by ed on 2/10/17.
 */
import React, { Component } from 'react';
import AncestorInput from './AncestorInput';
import FormErrorDisplay from './FormErrorDisplay';
// import Implode from '../helpers/HelperTools';

class AncestryLevelForm extends Component {

    constructor() {
        super();
        this.state = {
            errors: []
        };

        this.storeData = this.storeData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBack = this.handleBack.bind(this);
    }

    /**
     * get values from one level up, each value will create a father and mother field using the value as label
     * if this is level 0, we create father & mother field with "Father" & "Mother"
     */
    elements(current, data) {
        let prevLevelValues = null;
        let currentLevelValues = [];
        if (data && current > 0 && data[current-1]) {
            prevLevelValues = data[current-1];
        }

        if (data && data[current]) {
            currentLevelValues = data[current];
        }

        let elements = {
            left: [],
            right: []
        };
        let me = this;
        if (prevLevelValues) {
            Object.keys(prevLevelValues).forEach(function(key,index) {
                me.createAncestorFields(elements, currentLevelValues, prevLevelValues[key], index, current);
            });
        } else {
            this.createAncestorFields(elements, currentLevelValues, null, 0, current);
        }
        return elements;
    }

    createAncestorFields(elements, current, child, i, currentLevel) {
        let mother_label = "Mother";
        let father_label = "Father";
        let id = currentLevel + "_" + i;
        let id_mother = id + "_mother";
        let id_father = id + "_father";
        let child_id = null;

        if (child) {
            mother_label = child.value + "'s " + mother_label;
            father_label = child.value + "'s " + father_label;
            child_id = child.id;
        }

        let currValMother = current[id_mother] ? current[id_mother].value : '';
        let currValFather = current[id_father] ? current[id_father].value : '';

        elements.left.push(<AncestorInput side="left" value={currValMother} label={mother_label} key={id_mother} id={id_mother} child_id={child_id} onInputChange={this.storeData} />);
        elements.right.push(<AncestorInput side="right" value={currValFather} label={father_label} key={id_father} id={id_father} child_id={child_id} onInputChange={this.storeData} />);
    }

    storeData(id, child_id, side, input) {
        this.props.onInputChange(id, child_id, side, input);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.validateForm(this.props.data[this.props.current])) {
            this.props.handleSubmit("next");
        }
    }

    handleBack(event) {
        event.preventDefault();
        this.props.handleSubmit("back");
    }

    validateForm(data) {
        let returnVal = true;
        if (!data || !Object.keys(data).length) {
            this.setState({
                errors: ['Please enter at least one ancestor to go to the previous generation.']
            });
            returnVal = false
        }
        return returnVal;
    }

    render() {
        const elements = this.elements(this.props.current, this.props.data);
        let left = [];
        let right = [];

        for (let i = 0, len = elements.left.length; i < len; i++) {
            left.push(
                <li>{elements.left[i]}</li>
            );
            right.push(
                <li>{elements.right[i]}</li>
            );
        }

        return (
            <div className="ancestry_level_form row">
                <ul className="left col-sm-6">
                    {left}
                </ul>
                <ul className="right col-sm-6">
                    {right}
                </ul>
                <div className="col-xs-12"></div>
                <FormErrorDisplay errors={this.state.errors} />
                {this.props.current > 0 ? (<button value="Back" className="btn btn-primary" onClick={this.handleBack}>Back to their children</button>) : ("") }
                <button value="Next" className="btn btn-primary" onClick={this.handleSubmit}>Enter their parents</button>
            </div>
        );
    }
}

export default AncestryLevelForm;


// WEBPACK FOOTER //
// ./src/components/AncestryLevelForm.js